/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SleepApneaProfileQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type SleepApneaProfileQuery = { __typename?: 'Query', sleepApnea: { __typename?: 'SleepApnea', id: string, apneaHypopneaIndex: number | null, apneaIndex: number | null, diagnosedAt: string | null, everTreated: boolean | null, oxygenSaturation: number | null, respiratoryDisturbanceIndex: number | null, severity: string | null, sleepStudyConducted: boolean | null, sleepStudyConductedAt: string | null, treatedAt: string | null, usesCPAPMachine: boolean | null }, currentUser: { __typename?: 'User', id: string, dateOfBirth: string | null } };

export type SleepApneaValuesFragment = { __typename?: 'SleepApnea', apneaHypopneaIndex: number | null, apneaIndex: number | null, diagnosedAt: string | null, everTreated: boolean | null, oxygenSaturation: number | null, respiratoryDisturbanceIndex: number | null, severity: string | null, sleepStudyConducted: boolean | null, sleepStudyConductedAt: string | null, treatedAt: string | null, usesCPAPMachine: boolean | null };

export const SleepApneaValuesFragmentDoc = gql`
    fragment SleepApneaValues on SleepApnea {
  apneaHypopneaIndex
  apneaIndex
  diagnosedAt
  everTreated
  oxygenSaturation
  respiratoryDisturbanceIndex
  severity
  sleepStudyConducted
  sleepStudyConductedAt
  treatedAt
  usesCPAPMachine
}
    `;
export const SleepApneaProfileDocument = gql`
    query SleepApneaProfile {
  sleepApnea {
    id
    ...SleepApneaValues
  }
  currentUser {
    id
    dateOfBirth
  }
}
    ${SleepApneaValuesFragmentDoc}`;
export function useSleepApneaProfileQuery(baseOptions?: Apollo.QueryHookOptions<SleepApneaProfileQuery, SleepApneaProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SleepApneaProfileQuery, SleepApneaProfileQueryVariables>(SleepApneaProfileDocument, options);
      }
export function useSleepApneaProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SleepApneaProfileQuery, SleepApneaProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SleepApneaProfileQuery, SleepApneaProfileQueryVariables>(SleepApneaProfileDocument, options);
        }
export function useSleepApneaProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SleepApneaProfileQuery, SleepApneaProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SleepApneaProfileQuery, SleepApneaProfileQueryVariables>(SleepApneaProfileDocument, options);
        }
export type SleepApneaProfileQueryHookResult = ReturnType<typeof useSleepApneaProfileQuery>;
export type SleepApneaProfileLazyQueryHookResult = ReturnType<typeof useSleepApneaProfileLazyQuery>;
export type SleepApneaProfileSuspenseQueryHookResult = ReturnType<typeof useSleepApneaProfileSuspenseQuery>;
export type SleepApneaProfileQueryResult = Apollo.QueryResult<SleepApneaProfileQuery, SleepApneaProfileQueryVariables>;